/* eslint-disable spaced-comment */
/* eslint-disable @typescript-eslint/camelcase */
import { ClientSSO, CreateClientProps } from 'modules/clients/interfaces';

export const init: CreateClientProps = {
  name: '',
  environment_uuid: '',
  email_admin: '',
  copy_admin: false,
  external_client_code: '',
  licenses: {
    available_licenses_to_client: 0,
    block_same_user_multiple_session: true,
    client_license: {
      has_license_limit: false,
      license_limit: 0,
    },
    license_group: {
      uuid: '',
      name: '',
      license_limit: 0,
    },
  },
  active_directory: {
    profile_path: '',
    remote_profile: false,
  },
  user_connection: {
    virtualizer: '',
    connect_port: null,
    service_port: null,
    use_ios_devices: false,
  },
  application_options: {
    disable_connection_status: false,
    enable_keepalive: false,
  },
  new_front: null,
  user_access_without_ad: {
    enabled: null,
    environment_enabled: false,
  },
};

export const ssoInitialFields: ClientSSO = {
  client_realm_id: '',
  federation_type: 'saml',
  restrict_access_by_groups: false,
  saml_idp_entity_id: 'https://example.com/adfs/services/trust',
  saml_idp_public_x509_cert: '',
  saml_idp_single_logout_url: 'https://example.com/adfs/ls/',
  saml_idp_single_sign_on_url: 'https://example.com/adfs/ls/',
  allow_users_from_group: '',
  saml_idp_claim_name_id:
    'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/upn', //NOSONAR ignore http url because microsoft does not provide a safer url
  saml_idp_claim_given_name:
    'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname', //NOSONAR ignore http url because microsoft does not provide a safer url
  saml_idp_claim_surname:
    'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname', //NOSONAR ignore http url because microsoft does not provide a safer url
  saml_idp_claim_email_address:
    'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress', //NOSONAR ignore http url because microsoft does not provide a safer url
  saml_idp_claim_groups:
    'http://schemas.microsoft.com/ws/2008/06/identity/claims/groups', //NOSONAR ignore http url because microsoft does not provide a safer url
};
